import React from "react";

const SvgIcon = ({ children, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    {children}
  </svg>
);

export const ChevronLeftIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M15.45 21l2.1-2.1-6.9-6.9 6.9-6.9-2.1-2.1-9 9 9 9z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const InfoIcon = props => (
  <SvgIcon {...props}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z" />
  </SvgIcon>
);

export const OnIcon = props => (
  <SvgIcon {...props}>
    <path d="M17.643 9.95l-5.647 6.352a1.408 1.408 0 0 1-1.937.165l-3.53-2.824a1.411 1.411 0 1 1 1.765-2.203l2.483 1.986 4.757-5.352a1.412 1.412 0 0 1 2.11 1.877z" />
  </SvgIcon>
);

export const StudentIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M12 7.172a2.584 2.584 0 0 1-2.585-2.586A2.584 2.584 0 0 1 12 2a2.584 2.584 0 0 1 2.585 2.586 2.584 2.584 0 0 1-2.585 2.586m0 .606c2.9 0 5.17 1.703 5.17 3.879v2.585c0 .715-.578 1.293-1.291 1.293h-1.294v5.172c0 .715-.579 1.293-1.293 1.293h-2.585a1.292 1.292 0 0 1-1.293-1.293v-5.172H8.122a1.292 1.292 0 0 1-1.293-1.293v-2.585c0-2.176 2.27-3.88 5.172-3.88v.001z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const RoomIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M7.394 20.104c.6.6 1.573.6 2.173 0l7.438-7.438c.213-.213.377-.469.484-.74.748.21 1.475.32 2.115.316 1.586-.008 2.111-.702 2.284-1.117.172-.41.295-1.273-.817-2.407l-.037-.037c-.69-.69-1.692-1.326-2.83-1.798-.21-.087-.419-.165-.624-.239v-.012a1.681 1.681 0 0 0-1.66-1.66l-4.456-.059a2.167 2.167 0 0 0-1.573.64l-7.44 7.438c-.6.6-.6 1.572 0 2.171l4.943 4.94v.002m5.734-12.53a1.272 1.272 0 0 1 2.156 1.083c.53.37 1.099.68 1.696.924.222.09.435.172.64.242l-.024-1.79c.037.016.07.028.107.045.973.406 1.848.957 2.41 1.52.01.007.017.016.025.024.534.546.592.896.546 1.002-.14.333-1.638.628-3.913-.32a8.786 8.786 0 0 1-1.795-.998c-.017.02-.037.04-.054.061a1.272 1.272 0 0 1-1.798 0 1.27 1.27 0 0 1 .004-1.794z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const PhoneIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M15.059 2H8.942a2.832 2.832 0 0 0-2.824 2.824v14.352A2.832 2.832 0 0 0 8.942 22h6.116a2.832 2.832 0 0 0 2.824-2.824V4.824A2.832 2.832 0 0 0 15.058 2h.001m-1.881 17.882h-2.354a.47.47 0 0 1 0-.94h2.353a.47.47 0 0 1 0 .94h.001m3.353-2.862h-9.06V5.235A1.73 1.73 0 0 1 9.197 3.51h5.608a1.73 1.73 0 0 1 1.726 1.725V17.02z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const BirthdayIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M12 5.205c.836 0 1.568-.732 1.568-1.569 0-.313-.104-.522-.209-.836L12 .5l-1.36 2.3a1.97 1.97 0 0 0-.208.836c0 .837.732 1.569 1.568 1.569m6.795 2.613h-5.75V6.25h-2.09v1.568h-5.75A4.685 4.685 0 0 0 .5 12.523c0 1.672.836 3.032 2.09 3.868V23.5h18.82v-7.11c1.254-.835 2.09-2.3 2.09-3.867a4.685 4.685 0 0 0-4.705-4.705m0 7.318c-.731 0-1.359-.313-1.881-.731l-1.569-1.569-1.568 1.569a2.522 2.522 0 0 1-1.777.731c-.732 0-1.36-.313-1.882-.731L8.55 12.836l-1.568 1.569a2.522 2.522 0 0 1-1.777.731 2.588 2.588 0 0 1-2.614-2.613 2.588 2.588 0 0 1 2.614-2.614h13.59a2.588 2.588 0 0 1 2.614 2.614 2.588 2.588 0 0 1-2.614 2.613z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const IdentificationIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M21.625 20.532c-.006.9-.85 1.623-1.88 1.619l-7.526-.002c.497-.305.824-.807.824-1.378l.006-4.784c0-.384-.185-.712-.426-1.004L9.646 11.28l2.879-2.548 2.967 3.547c.528.55 1.467.622 2.096.16.63-.462.712-1.282.183-1.832l-4.514-5.542c-.771-.804-2.525-.95-3.444-.276L5.23 8.794s-1.626 1.087-.143 2.885l4.113 5.1-.007 3.992c0 .57.326 1.073.823 1.377l-8.89-.002-.001 1.094 18.614.01c1.724.008 3.127-1.2 3.136-2.707l-1.25-.011M15.962 5.666c1.553 0 2.812-1.1 2.812-2.458S17.516.75 15.963.75s-2.813 1.1-2.813 2.458c0 1.357 1.26 2.458 2.813 2.458h-.001z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const SkiIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M6.604 5.4c-.315-.008-.913-.363-.932-1.184-.019-.82.168-1.89.168-1.89s.322 1.07.455 1.303c.133.235.537.576.537.576S6.92 5.408 6.605 5.4M17.08 4.205s.404-.34.537-.576c.133-.234.455-1.304.455-1.304s.185 1.072.167 1.892c-.02.82-.618 1.176-.932 1.183-.315.008-.227-1.195-.227-1.195m4.1 14.077c-2.912-2.194-1.226-.699-7.02-5.073l-.24-.183a63.362 63.362 0 0 1-.003-.703c3.152-2.685 4.45-3.459 6.734-5.52 2.85-2.572 2.268-3.14 1.882-3.547-.37-.39-.91-1.024-3.76 1.548-1.873 1.69-2.815 2.805-4.745 4.727l.024-.227 2.647-4.757.194-.014s.002.894.304 1.127c.301.234 1.133-.423 1.216-1.095.084-.672-.09-2.42-.09-2.42s.184-.28-.046-.51c-.23-.23-.59-.273-.692-.157-.103.115.048.461.048.461l-1.039 1.854s-.262-.062-.363.005c-.1.068.142.515.142.515l-2.185 3.96c.053-.417.092-.86.09-1.575-.009-2.195-1.128-2.844-2.294-2.836-1.115.008-2.277.674-2.27 2.87.003.813.057 1.278.125 1.748l-2.3-4.167s.241-.447.141-.515c-.1-.067-.362-.005-.362-.005l-1.04-1.855s.152-.346.05-.46c-.104-.117-.464-.074-.693.156-.23.23-.046.51-.046.51s-.174 1.748-.09 2.42c.083.672.914 1.33 1.216 1.095.302-.233.303-1.127.303-1.127l.194.014 2.766 4.97c.015.133.03.274.042.432C7.742 8.06 6.705 7.01 4.606 5.424 1.543 3.11 1.06 3.79.726 4.21c-.35.44-.88 1.057 2.183 3.37 2.458 1.857 3.82 2.514 7.204 4.923l.001.153v.571l-.18.164c-5.39 4.863-3.842 3.226-6.55 5.665C.92 21.271.906 21.313 1.63 22.115c.68.755.724.817 3.262-1.468 2.75-2.475 1.217-1.307 5.117-4.86l-.006.062-2.626 4.755s-.402-.166-.48-.049c-.079.116.294.378.294.378l-.228.664.505-.408s.377.164.455.072c.077-.093-.265-.473-.265-.473l2.236-4.018c-.077.568-.143 1.043-.14 1.925.007 2.086 1.178 2.733 2.293 2.725 1.166-.008 2.278-.452 2.27-2.758a12.56 12.56 0 0 0-.083-1.497l2.016 3.623s-.342.38-.265.473c.077.092.455-.072.455-.072l.505.408-.229-.664s.373-.262.295-.378c-.079-.117-.48.05-.48.05l-2.43-4.403a15.184 15.184 0 0 1-.089-.812c4.547 3.458 2.782 2.334 5.8 4.608 2.728 2.055 2.767 1.99 3.378 1.18.65-.864.633-.904-2.012-2.897z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const StarIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M17.599 15.793c-1.079.919-2.251 1.598-3.265 2.142v.03l-.028-.016-.045.025-.015.008-.117-.028a9.54 9.54 0 0 0-2.113-.233h-.033a9.475 9.475 0 0 0-2.11.233l-.118.027-.015-.007a1.984 1.984 0 0 0-.046-.025l-.027.016v-.03c-1.015-.544-2.186-1.223-3.265-2.142l-.046-.039 1.127-.663v-1.947l.957-.562v1.947l1.185-.696v-1.947l.186-.11 1.597.94v.217l-1.657.974V15.3l1.657-.974v1.125l-1.657.973v1.393L12 16.495l2.25 1.322v-1.394l-1.658-.972v-1.124l1.657.972v-1.391l-1.657-.974v-.218l1.598-.938.185.11v1.946l1.185.696v-1.947l.956.562v1.947l1.129.663-.046.04v-.002m-7.196-6.938L12 7.917l1.597.939v1.877L12 11.671l-1.598-.938V8.855h.001m13.321 6.1l-.414.085c-.247.052-.539.119-.865.2l-.116.028.073-.096a7.683 7.683 0 0 0 1.02-1.822l.151-.392a.044.044 0 0 0-.01-.047.043.043 0 0 0-.046-.009l-1.791.81.006-.072c.138-1.875-.5-2.629-.507-2.636l-.18-.21a.044.044 0 0 0-.032-.014c-.016.003-.028.01-.033.018-.03.092-.067.181-.11.268-.668 1.825-1.68 3.324-3.099 4.577l-.07.061v-2.56l.022-.012 2.227-1.309-1.185-.697-1.655.974-.957-.562 1.656-.973-1.185-.697-1.657.973-.185-.108V8.855l.185-.108 1.657.972 1.185-.695-1.657-.974.957-.562 1.656.974 1.185-.697-1.655-.973 1.257-.74-.592-1.044-1.258.74V3.8l-1.186.696v1.947l-.956.562V5.059l-1.185.697v1.946l-.185.11-1.598-.94v-.217l1.657-.974V4.288l-1.657.974V4.138l1.657-.973V1.771l-1.657.973V1.267h-1.184v1.478L9.75 1.772v1.393l1.657.972v1.125L9.75 4.288v1.393l1.657.974v.217l-1.599.94-.185-.11V5.757L8.439 5.06v1.947l-.957-.562V4.497L6.297 3.8v1.947L5.04 5.01l-.594 1.044 1.258.739-1.655.974 1.185.697 1.657-.974.956.561-1.656.974 1.185.696 1.657-.973.185.11v1.876l-.185.108-1.657-.973-1.185.697 1.657.973-.957.562-1.657-.973-1.185.696 2.25 1.321v2.56l-.07-.06c-1.419-1.254-2.432-2.753-3.1-4.582a1.789 1.789 0 0 1-.108-.264.042.042 0 0 0-.028-.017c-.018 0-.03.005-.038.014l-.18.209c-.007.007-.645.76-.506 2.636l.006.073-1.791-.81a.043.043 0 0 0-.046.008.043.043 0 0 0-.011.046l.151.393a7.67 7.67 0 0 0 1.021 1.822l.073.096-.117-.028a24.174 24.174 0 0 0-.865-.2l-.406-.083c-.022-.002-.037.006-.043.018a.041.041 0 0 0 0 .048l.232.35c2.215 3.102 5.693 4.297 7.4 4.514.034.004.069.005.104.001l.022-.002.013.018c.571.68 2.167 1.141 3.971 1.147h.033c1.804-.006 3.401-.468 3.972-1.147l.014-.018.022.002c.035.004.07.003.105 0 1.705-.218 5.183-1.413 7.4-4.517l.231-.348a.045.045 0 0 0 0-.048.043.043 0 0 0-.037-.02h.001z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const CardIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M.137 9.685v-4.37A2.865 2.865 0 0 1 3 2.452H21a2.865 2.865 0 0 1 2.864 2.865v4.37a2.315 2.315 0 0 0 0 4.629v4.37A2.865 2.865 0 0 1 21 21.548H3a2.865 2.865 0 0 1-2.864-2.865v-4.37a2.315 2.315 0 0 0 0-4.629M12 15.328l4.252 2.234-.812-4.734 3.44-3.353-4.753-.69L12 4.477 9.874 8.785l-4.754.69 3.44 3.353-.811 4.735L12 15.328z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const ClockIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M12 .382C5.61.382.382 5.61.382 12 .382 18.39 5.61 23.617 12 23.617c6.39 0 11.617-5.227 11.617-11.617C23.617 5.61 18.39.382 12 .382m0 20.912c-5.112 0-9.294-4.182-9.294-9.294S6.888 2.706 12 2.706 21.294 6.888 21.294 12 17.112 21.294 12 21.294m.58-15.103h-1.742v6.97l6.041 3.718.93-1.51-5.228-3.137v-6.04z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const MountIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M23.317 23.681H.683l1.123-1.916 3.497-5.958c.618-1.053 1.627-1.053 2.244 0 0 0 .812 1.383.91 1.545l2.942-5.016c.621-1.052 1.63-1.052 2.246 0l4.923 8.39c.255-.434.505-.859.696-1.191.448-.76 1.175-.76 1.624 0 .445.761 1.175 2.005 1.623 2.76l.806 1.386M12.69 3.6c0 1.086-.896 1.969-2 1.969-1.105 0-2.001-.883-2.001-1.97 0-1.086.896-1.968 2-1.968 1.105 0 2.001.882 2.001 1.969m1.336 0c0 .536-.132 1.044-.362 1.49L10.69 10.82S7.693 5.043 7.682 5.018A3.214 3.214 0 0 1 7.353 3.6c0-1.812 1.494-3.281 3.337-3.281 1.842 0 3.335 1.469 3.335 3.282V3.6z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const CalendarIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M23.3 3.267h-3.208v.81a2.427 2.427 0 0 1-4.852 0v-.81H8.765v.81a2.43 2.43 0 0 1-2.427 2.428 2.43 2.43 0 0 1-2.424-2.427v-.811l-3.24-.038v20.26h21.034l1.617-.003L23.3 3.268v-.001m-1.593 18.609H2.294V8.93h19.414v12.945h-.001M17.639 5.36a1.59 1.59 0 0 1-1.594-1.59V2.105A1.59 1.59 0 0 1 17.64.51c.881 0 1.593.712 1.593 1.594v1.665a1.59 1.59 0 0 1-1.593 1.59m-11.325 0A1.588 1.588 0 0 1 4.72 3.77V2.106c0-.884.71-1.595 1.593-1.595.88 0 1.594.71 1.594 1.594v1.665a1.59 1.59 0 0 1-1.594 1.59m2.457 5.31h2.548v2.25H8.772v-2.25m4.122 0h2.551v2.25h-2.553v-2.25h.002m3.822 0h2.55v2.25h-2.549v-2.25h-.001M8.77 14.404h2.548v2.25H8.772v-2.25m4.122 0h2.551v2.25h-2.553v-2.25h.002m3.822 0h2.55v2.25h-2.549v-2.25h-.001m-7.944 3.812h2.548v2.249H8.772v-2.25m-4.05-3.81h2.547v2.25H4.721v-2.25m0 3.812H7.27v2.249H4.721v-2.25m8.171 0h2.553v2.25h-2.553v-2.25m3.824 0h2.55v2.25h-2.549v-2.25h-.001z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const MarkerIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M16.313 7.687a4.315 4.315 0 0 0-4.312-4.314 4.315 4.315 0 0 0 0 8.628 4.315 4.315 0 0 0 4.312-4.314m2.877 0a7.146 7.146 0 0 1-.782 3.264l-6.407 12.552S5.54 10.846 5.516 10.793A7.19 7.19 0 1 1 19.19 7.686z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const LoginIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11m2.125-16.802a2.197 2.197 0 1 0-4.395 0c0 1.215.983 2.198 2.198 2.198a2.197 2.197 0 0 0 2.198-2.198h-.001m-6.594 6.01v2.198a1.1 1.1 0 0 0 1.1 1.1h1.098V19.9a1.1 1.1 0 0 0 1.1 1.099h2.197a1.1 1.1 0 0 0 1.1-1.099v-4.396h1.098a1.1 1.1 0 0 0 1.1-1.099v-2.198c0-1.85-1.932-3.297-4.397-3.297-2.465 0-4.396 1.448-4.396 3.297v.001z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const PasswordIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M12 .75C18.213.75 23.25 5.787 23.25 12S18.213 23.25 12 23.25.75 18.213.75 12 5.787.75 12 .75zm3.457 17.034c.73 0 1.322-.592 1.322-1.322v-4.27c0-.636-.451-1.167-1.05-1.293V8.972A3.733 3.733 0 0 0 12 5.243a3.733 3.733 0 0 0-3.728 3.729v1.927c-.6.125-1.05.657-1.05 1.294v4.269c0 .73.591 1.322 1.322 1.322h6.913zM12 7.19c.984 0 1.783.8 1.783 1.783v1.899h-3.566v-1.9c0-.982.8-1.782 1.783-1.782zm0 5.673a1.17 1.17 0 0 1 .584 2.182v1.3h-1.168v-1.3A1.169 1.169 0 0 1 12 12.862z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const MountainIcon = props => (
  <SvgIcon {...props}>
    <path
      d="M3.59 19.76A10.956 10.956 0 0 1 1 12.67c0-6.074 4.925-11 11-11s11 4.926 11 11c0 2.653-.938 5.085-2.501 6.985l-.51-.873c-.401-.676-1.048-.676-1.447 0-.17.297-.393.675-.619 1.06l-4.383-7.468c-.55-.937-1.447-.937-2 0 0 0-2.205 3.76-2.62 4.465-.087-.144-.81-1.376-.81-1.376-.548-.937-1.447-.937-1.998 0L3.59 19.762v-.001M14.7 5.013c0-1.32-1.087-2.391-2.43-2.391-1.343 0-2.431 1.07-2.431 2.39 0 .37.085.723.238 1.035l2.193 4.228 2.167-4.176c.169-.325.264-.695.264-1.086H14.7m-.971 0c0 .793-.654 1.435-1.459 1.435a1.447 1.447 0 0 1-1.459-1.435c0-.792.654-1.434 1.459-1.434s1.459.642 1.459 1.434z"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export const ChatIcon = props => (
  <SvgIcon {...props}>
    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </SvgIcon>
);

export const DropDownIcon = props => (
  <SvgIcon {...props}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z" />
  </SvgIcon>
);

export const CloseIcon = props => (
  <SvgIcon {...props}>
    <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
  </SvgIcon>
);



// WEBPACK FOOTER //
// ./src/Icons.js